const namespace = "roles";

export const roles = `${namespace}_list`;
